export const BOOG_SLUG = 'boog-bijzettafel-eigen-ontwerp';
export const isBoogProduct = (slug?: string) => slug === BOOG_SLUG;
export type BoogMaterial = 'multiplex_9mm' | 'forex_10mm_double';
export const getBoogMaterial = (value: unknown): BoogMaterial => value === 'forex_10mm_double' ? 'forex_10mm_double' : 'multiplex_9mm';
export const boogRevision = (material: BoogMaterial) => material === 'forex_10mm_double' ? 'boog-002-forex10-r01' : 'boog-002-r01';
